import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './roomload.css';
import Roomloadcomp from '../components/common/roomloadcomp';

const Roomload = () => {
  const canvasRef = useRef(null);
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationFrameId;

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    const particles = Array.from({ length: 60 }, () => ({
      x: Math.random() * window.innerWidth,
      y: Math.random() * window.innerHeight,
      size: Math.random() * 2 + 0.5,
      speedY: -(Math.random() * 0.5 + 0.2),
      speedX: (Math.random() - 0.5) * 0.3,
      opacity: Math.random() * 0.6 + 0.1,
      flicker: Math.random() * Math.PI * 2,
    }));

    const animateParticles = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach((particle) => {
        particle.x += particle.speedX;
        particle.y += particle.speedY;
        particle.flicker += 0.02;

        if (particle.y < -10) {
          particle.y = canvas.height + 10;
          particle.x = Math.random() * canvas.width;
        }

        const alpha =
          particle.opacity *
          (0.6 + 0.4 * Math.sin(particle.flicker));

        ctx.beginPath();
        ctx.arc(
          particle.x,
          particle.y,
          particle.size,
          0,
          Math.PI * 2
        );

        ctx.fillStyle = `rgba(212,175,55,${alpha})`;
        ctx.shadowColor = '#D4AF37';
        ctx.shadowBlur = 8;
        ctx.fill();
      });

      animationFrameId = requestAnimationFrame(animateParticles);
    };

    animateParticles();

    return () => {
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener('resize', resizeCanvas);
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setReady(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const handleStartInvestigation = () => {
    navigate('/room1');
  };

  return (
    <section className="roomload">
      <canvas
        ref={canvasRef}
        className="dust-canvas"
      />

      <div className="vignette"></div>

      <h1 className="hoteltt">
        MYSTERY HOTEL
      </h1>

      <Roomloadcomp
        leveltext="Level 1"
        levelname="The Locked Room"
        roomdes="A guest has been found unconscious in Room 405. The door was locked from the inside. Something isn't right."
        missonobj="Mission Objectives"
        misson1="Investigate Room 405"
        misson2="Collect Clues"
        misson3="Solve The Mystery"
      />

      <button
        className={`startinv ${ready ? 'startinv--ready' : ''}`}
        onClick={handleStartInvestigation}
        disabled={!ready}
      >
        Start Investigation
      </button>

      <h6 className="pagedes">
        <span className="pagedes-gem">◆</span>
        Tip: Not every clue is obvious. Inspect objects carefully.
      </h6>
    </section>
  );
};

export default Roomload;